import { Link } from 'react-router-dom';

export default function WhyUsHero() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute right-0 top-0 w-[45%] h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-800/30 to-brand-700/90"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20network%20diagram%20with%20interconnected%20nodes%20and%20glowing%20connections%20on%20a%20dark%20navy%20blue%20background%20representing%20a%20digital%20logistics%20platform%20infrastructure%2C%20clean%20futuristic%20data%20visualization%20aesthetic%2C%20minimal%20grid%20lines%2C%20subtle%20amber%20and%20teal%20accent%20highlights%2C%20wide%20cinematic%20composition&width=900&height=800&seq=freshhlock-whyus-hero&orientation=portrait"
          alt="Digital network infrastructure visualization"
          className="w-full h-full object-cover opacity-15"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[460px] md:min-h-[520px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/40 border border-brand-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-brand-100 uppercase tracking-widest">
                Why Freshhlock
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-5 text-balance">
              We Don&apos;t Own the Chain.<br />We Make It Work.
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Freshhlock is the technology layer that connects India&apos;s fragmented cold chain — warehousing, transport, wholesale and retail — into one intelligent network. Asset-light by design. Network-first by conviction.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/contact"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Talk to Our Team
              </Link>
              <a
                href="#our-model"
                className="px-8 py-3.5 border border-brand-300/50 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </a>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}